import React from 'react'
import { KTIcon } from '../../../../../../../_metronic/helpers'
import { toast } from 'react-toastify'

interface Props {
    onNext: () => void
    onBack: () => void
    selectedProcess: any
    inputMaterial: any[]
    outputMaterial: any[]
    setInputMaterial: (material: any[]) => void
    setOutputMaterial: (material: any[]) => void
}

const OpsInputStep: React.FC<Props> = ({ onNext, onBack, selectedProcess, inputMaterial, outputMaterial, setInputMaterial, setOutputMaterial }) => {

    const handleReviewBtn = () => {
        const inputTotal = inputMaterial?.reduce((acc, item) => acc + (item?.enteredValue || 0), 0)
        const outputTotal = outputMaterial?.reduce((acc, item) => acc + (item?.enteredValue || 0), 0)
        if (!inputTotal || !outputTotal) {
            toast.error("Please enter input and output quantities")
            return
        }
        if (inputTotal >= outputTotal && inputTotal - outputTotal <= 0.5) {
            onNext()
        } else {
            toast.error("Input and output quantities must be equal")
            return
        }

    }

    return (
        <div className='card card-flush h-xl-100'>
            {/* Header */}
            <div className='card-header pt-7'>
                <div className='card-title d-flex align-items-center'>
                    <button onClick={onBack} className='btn btn-icon btn-sm btn-active-light-primary me-3'>
                        <KTIcon iconName='arrow-left' className='fs-2' />
                    </button>
                    <h2 className='card-label fw-bolder text-dark fs-2 mb-0 '>{selectedProcess?.name}</h2>
                </div>
                <div className='card-toolbar'>
                    <span className='text-success fw-bolder fs-4'>2</span>
                    <span className='text-dark fw-bold fs-6 ms-1'>of 3</span>
                </div>
            </div>

            <div className='card-body pt-5'>
                {/* Input Section */}
                <div className='mb-10'>

                    <h2 className='d-inline-block fw-bolder text-white bg-success p-3 rounded-4 mb-7'>
                        Input information
                    </h2>

                    <div className='table-responsive'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                                <tr className='fw-bolder text-dark'>
                                    <th className='min-w-150px'>Category</th>
                                    <th className='min-w-150px'>Material</th>
                                    <th className='min-w-100px text-center'>Available stock (kg)</th>
                                    <th className='min-w-100px text-end'>Input Qty (kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {inputMaterial?.map((material: any) => (
                                    <tr key={material?.id}>
                                        <td>
                                            <span className='text-dark fw-bolder fs-6'>{material?.categoryName}</span>
                                        </td>
                                        <td>
                                            <span className='text-dark fw-bolder fs-6'>{material?.name}</span>
                                        </td>
                                        <td className='text-center'>
                                            <span className='badge badge-light-primary fw-bolder fs-7'>{material?.stock?.toFixed(2)} kg</span>
                                        </td>

                                        <td className='text-end'>
                                            <div className='d-flex justify-content-end'>
                                                <input
                                                    type='number'
                                                    className='form-control form-control-solid fw-bolder text-end'
                                                    style={{ width: '120px' }}
                                                    min='0'
                                                    max={material.stock}
                                                    placeholder='0'
                                                    value={material?.enteredValue}
                                                    onChange={(e) => {
                                                        const value = e.target.value
                                                        if (!value || +value < 0 || +value > material.stock) {
                                                            setInputMaterial(inputMaterial.map((item) => item.id === material.id ? { ...item, enteredValue: 0 } : item))
                                                            return
                                                        }
                                                        const numValue = parseFloat(value)
                                                        if (!isNaN(numValue) && numValue >= 0 && numValue <= material.stock) {
                                                            setInputMaterial(inputMaterial.map((item) => item.id === material.id ? { ...item, enteredValue: numValue } : item))
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* <button className='btn btn-outline btn-outline-dashed btn-outline-default w-100 rounded-pill py-4 fw-bolder fs-5 border-2 text-dark'>
                        + Add Input
                    </button> */}
                </div>

                {/* Output Section */}
                <div className='separator separator-dashed my-10'></div>

                <div className='mb-5'>
                    <h2 className='d-inline-block fw-bolder text-white bg-success p-3 rounded-4 mb-7'>
                        Output information
                    </h2>

                    <div className='table-responsive'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            <thead>
                                <tr className='fw-bolder text-dark'>
                                    <th className='min-w-150px'>Category</th>
                                    <th className='min-w-150px'>Material</th>
                                    <th className='min-w-100px text-center'></th>
                                    <th className='min-w-100px text-end'>Quantity (kg)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {outputMaterial?.map((material: any) => (
                                    <tr key={material?.id}>
                                        <td>
                                            <span className='text-dark fw-bolder fs-6'>{material?.categoryName}</span>
                                        </td>
                                        <td>
                                            <span className='text-dark fw-bolder fs-6'>{material?.name}</span>
                                        </td>
                                        <td className='text-center'></td>
                                        <td className='text-end'>
                                            <div className='d-flex justify-content-end'>
                                                <input
                                                    type='number'
                                                    className='form-control form-control-solid fw-bolder text-end'
                                                    style={{ width: '120px' }}
                                                    min='0'
                                                    placeholder='0'
                                                    value={material?.enteredValue}
                                                    onChange={(e) => {
                                                        const value = e.target.value
                                                        if (!value || +value < 0) {
                                                            setOutputMaterial(outputMaterial.map((item) => item.id === material.id ? { ...item, enteredValue: 0 } : item))
                                                            return
                                                        }
                                                        const numValue = parseFloat(value)
                                                        if (!isNaN(numValue) && numValue >= 0) {
                                                            setOutputMaterial(outputMaterial.map((item) => item.id === material.id ? { ...item, enteredValue: numValue } : item))
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className='d-flex justify-content-center'>

                        <button onClick={handleReviewBtn} className='btn btn-dark  rounded-pill py-4 fw-bolder fs-4'>
                            Review summary
                        </button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export { OpsInputStep }